var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.707 10.464a1 1 0 00-1.414 1.414l2.121 2.121-2.121 2.122a1 1 0 001.414 1.414l2.822-2.822a1 1 0 00.006-1.42l-2.828-2.83z",
    fill: "#424242"
  })));
};
export default __webpack_public_path__ + "static/media/rightArrow.39e456e3.svg";
export { SvgRightArrow as ReactComponent };